import React from 'react'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import TaxesKeyAuthContainer from '../containers/TaxesKeyAuth/TaxesKeyAuth.container'

/**
 * The TaxesKeyAuth' page.
 */
const TaxesKeyAuth = () => {
  return (
    <ProtectByAccessToken>
      <TaxesKeyAuthContainer />
    </ProtectByAccessToken>
  )
}

export default TaxesKeyAuth
